import { useQuery } from 'react-query';
import { AutocompleteType } from 'src/core/types';

import axios from './axios';

export interface UseAutocompleteQueryProps {
  text?: string;
  type: AutocompleteType;
}

export function useAutocompleteQuery<T extends Object>(
  props: UseAutocompleteQueryProps,
) {
  const { text = '', type } = props;

  return useQuery<T>(
    [`${type}-autocomplete`, text],
    async () => {
      return axios
        .get<T>(`/posht/ashena/${type}/auto-complete/?search=${text}`)
        .then((res) => res.data);
    },
    {
      suspense: false,
    },
  );
}
